import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ConfigService, ErrorsService, Setting} from 'shared';
import {Observable, throwError} from 'rxjs';
import {catchError, map, tap} from 'rxjs/operators';
import {keyBy, mapValues} from 'lodash';
import DataSource from 'devextreme/data/data_source';
import CustomStore from 'devextreme/data/custom_store';
import {LoadOptions} from 'devextreme/data/load_options';
import ArrayStore from 'devextreme/data/array_store';

export class Settings {
  private readonly all: any;

  constructor(s: Setting[]) {
    this.all = mapValues(keyBy(s, 'name'), 'value');
  }

  get(name: string, def?: any) {
    return this.all[name] || def;
  }

  set(name: string, values: any) {
    return this.all[name] = values;
  }
}

@Injectable({
  providedIn: 'root'
})
export class SettingsService {

  settings;

  constructor(private http: HttpClient, private config: ConfigService, private errors: ErrorsService) {
  }

  fetch(): Observable<Settings> {
    return this.http.get<Setting[]>(this.config.apiVerUrl('/app/settings')).pipe(
      map<Setting[], Settings>((s) => {
        return new Settings(s);
      }),
    );
  }

  settingListDataSource(settings: Settings, name: string, key: string, options?: any): DataSource {
    // Array Store
    const store = new ArrayStore({
      key,
      data: settings.get(name, []),
      onModified: async () => {
        const all = await store.load();
        this.http.post<any>(this.config.apiVerUrl('/app/settings/' + name), {value: JSON.stringify(all)}).pipe(
          catchError(err => {
            this.errors.handle(err);
            return throwError(err);
          })
        ).subscribe();
      },
    });

    const allOptions = options || {};
    allOptions.store = store;

    // Data source
    return new DataSource(allOptions);
  }
}
